import { gql } from '@apollo/client';

// Duplicate check for the Add Client modal: any supplied field can match, so one strong signal such
// as a contact number is enough to surface someone who is already on the system.
export const FIND_POSSIBLE_CASE_MATCHES = gql`
  query findPossibleCaseMatches($input: FindPossibleCaseMatchesInput!) {
    matches: findPossibleCaseMatches(input: $input) {
      id
      caseId
      firstName
      lastName
      dateOfBirth
      contactNumber
      clientStatus
      caseStatus
      caseWorker
      lastActivityDate
    }
  }
`;
